import { render, staticRenderFns } from "./TechnologyIssueBody.vue?vue&type=template&id=4efb085d&scoped=true"
import script from "./TechnologyIssueBody.vue?vue&type=script&lang=js"
export * from "./TechnologyIssueBody.vue?vue&type=script&lang=js"
import style0 from "./TechnologyIssueBody.vue?vue&type=style&index=0&id=4efb085d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb085d",
  null
  
)

export default component.exports